import { useQuery } from "react-query"
import { useMemo } from "react"
import { showCustomArticlesDefaults } from ".."
import { DEFAULTS_KEY } from "./keys"

export function useCustomArticlesDefaults(productGroupId?: number) {
    const { data, isLoading, isError } = useQuery([DEFAULTS_KEY], () => showCustomArticlesDefaults(), {
        staleTime: Infinity,
    })

    const categoryId = useMemo(() => {
        if (data?.categories && productGroupId) {
            return data.categories.find((x) => x.productGroupIds.includes(productGroupId))?.categoryId
        }

        return undefined
    }, [data, productGroupId])
    return { categoryId, customArticlesDefaults: data, defaultVatRatesLoading: isLoading, customArticlesDefaultsError: isError }
}
